module.exports = __webpack_public_path__ + "static/media/h1.0a556636.png";